import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const DecryptionView = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  const viewRoundsPage = () => {
    navigate("/rounds", {
      state: {
        AlldecryptionResults,
        bytes,
        splitted_array,
        hexKeyValue,
        allResults,
        randomNum,
      },
    });
  };

  const ip = () => {
    navigate("/page1", {
      state: { binaryCiphertext, bytes },
    });
  };

  const Keygen = () => {
    navigate("/keygen", {
      state: { allResults },
    });
  };

  const fp = () => {
    navigate("/final", {
      state: { binary64bitValueSwapped },
    });
  };

  const location = useLocation();

  const key = location.state.key;
  const DecryptedPlainText = location.state.DecryptedPlainText;
  const hexKeyValue = location.state.hexKeyValue;
  const AlldecryptionResults = location.state.AlldecryptionResults;
  const binary64bitValueSwapped = location.state.binary64bitValueSwapped;
  const bytes = location.state.bytes;
  const splitted_array = location.state.splitted_array;
  const allResults = location.state.allResults;
  const hexbytes = location.state.hexbytes;
  const binaryCiphertext = location.state.binaryCiphertext;
  const asciiDecryptedPlainText = location.state.asciiDecryptedPlainText;

  const SboxOutputs = AlldecryptionResults[0]; //has all the S-box values
  const PboxOutputs = AlldecryptionResults[1]; //has all the P-box values
  const decryptionResults = AlldecryptionResults[2]; //has all the 64 values
  const expansionPermOutputs = AlldecryptionResults[3]; //has all expansion permutation values

  console.log("binary64bitValueSwapped :", binary64bitValueSwapped);

  const binaryToHexadecimal = (binaryArray) => {
    let binaryString = "";
    for (let i = 0; i < 4; i++) {
      binaryString += binaryArray[0][i];
    }
    for (let i = 0; i < 4; i++) {
      binaryString += binaryArray[1][i];
    }
    //console.log(binaryString)
    let hexadecimalResult = "";

    for (let i = 0; i < 8; i++) {
      const chunk = binaryString.slice(i * 8, (i + 1) * 8);
      const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
      hexadecimalResult += hexDigit;
      if (i < 7) {
        hexadecimalResult += " "; // Add a space between every two characters
      }
    }

    return hexadecimalResult;
  };

  const beforeSwap = binaryToHexadecimal(decryptionResults[15]);

  let length = beforeSwap.length;
  console.log(length);
  const afterSwap =
    beforeSwap.slice(length / 2 + 1) + beforeSwap.slice(0, length / 2);

  const min = 5;
  const max = 15;
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;

  return (
    <>
      <div>
        <div className="content-box">
          <h3 className="head">What is done in this page?</h3>
          <p>
            This page highlights the various steps like Initial Permutation,
            Round wise key Generation, Various rounds of encryption, final
            permutation etc which are involved in the DES decryption. After the
            ciphertext and key is passed through all these various steps, we get
            the desired decrypted plaintext.<br></br>
            <br></br>
            Press the <b>view</b> buttons to visualise what's been done in
            various steps involved.
          </p>
        </div>
        <div className="grid grid-cols-5 h-2/5">
          <div className="col-span-4 grid grid-cols-7 items-center  w-3/5 ml-auto mr-auto mt-0">
            {/* 13 rows */}
            <div className="flex flex-col items-center justify-center h-screen mt-0 ">
              <h1 class="mt-0 mb-0 text-center">Ciphertext</h1>
              <div class="border-solid border-black border-2 p-0 w-48 ">
                <p class="m-0">{DecryptedPlainText}</p>
              </div>
              <div>
                <svg
                  width="30"
                  height="50"
                  viewBox="0 0 31 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="m"
                >
                  <g filter="url(#filter0_d_253_6)">
                    <path
                      d="M14.4213 51.5319C15.0071 52.1176 15.9568 52.1176 16.5426 51.5319L26.0885 41.9859C26.6743 41.4001 26.6743 
40.4504 26.0885 39.8646C25.5027 39.2788 24.553 39.2788 23.9672 39.8646L15.4819 48.3499L6.99665 39.8646C6.41087 
39.2788 5.46112 39.2788 4.87533 39.8646C4.28955 40.4504 4.28955 41.4001 4.87533 41.9859L14.4213 51.5319ZM13.9819 
0.471191L13.9819 50.4712H16.9819L16.9819 0.471191L13.9819 0.471191Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_253_6"
                      x="0.436035"
                      y="0.471191"
                      width="30.0918"
                      height="59.5"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_253_6"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_253_6"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>

              <div className="bg-blue-700 text-white text-center border-solid  border-2 p-1 w-60 rounded-lg mt-0">
                <p className="text-center">Initial Permutation</p>
                <button
                  className="bg-white text-black px-4 py-2 mt-2 rounded hover:bg-blue-200  transition duration-300"
                  onClick={ip}
                >
                  View
                </button>
                <div className="pb-4"></div>{" "}
                {/* Add padding below the button */}
              </div>

              <svg
                width="32"
                height="108"
                viewBox="0 0 32 108"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_334_2)">
                  <path
                    d="M14.9393 99.0607C15.5251 99.6464 16.4749 99.6464 17.0607 99.0607L26.6066 89.5147C27.1924 88.9289 27.1924 87.9792 26.6066 87.3934C26.0208 86.8076 25.0711 86.8076 24.4853 87.3934L16 95.8787L7.51472 87.3934C6.92893 86.8076 5.97918 86.8076 5.3934 87.3934C4.80761 87.9792 4.80761 88.9289 5.3934 89.5147L14.9393 99.0607ZM14.5 0L14.5 98H17.5V0L14.5 0Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_334_2"
                    x="0.954102"
                    y="0"
                    width="30.0918"
                    height="107.5"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_334_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_334_2"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <div className=" text-black text-center p-1 w-60 rounded-lg mt-0">
                <p>Permutation</p>
                <div class="border-solid border-black border-2 p-0 w-48 ml-6 ">
                  <p class="m-0">{hexbytes}</p>
                </div>
                <div className="pb-4"></div>{" "}
                {/* Add padding below the button */}
              </div>
            </div>
            {/* {/second  grid/} */}
            {/* Grid 2 */}
            <div class="ml-12 mt-80 ">
              <svg
                width="60"
                height="32"
                viewBox="0 0 60 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_334_3)">
                  <path
                    d="M55.5607 13.0607C56.1464 12.4749 56.1464 11.5251 55.5607 10.9393L46.0147 1.3934C45.4289 0.807612 44.4792 0.807612 43.8934 1.3934C43.3076 1.97918 43.3076 2.92893 43.8934 3.51472L52.3787 12L43.8934 20.4853C43.3076 21.0711 43.3076 22.0208 43.8934 22.6066C44.4792 23.1924 45.4289 23.1924 46.0147 22.6066L55.5607 13.0607ZM4 13.5L54.5 13.5V10.5L4 10.5L4 13.5Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_334_3"
                    x="0"
                    y="0.954102"
                    width="60"
                    height="30.0918"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_334_3"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_334_3"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>

            {/* {/Third grid/} */}
            <div class="flex flex-col items-center justify-center h-screen ml-32">
              <h1 class="mt-0 mb-0 text-center">Key</h1>
              <div class="border-solid border-black border-2 p-0 w-48">
                <p class="m-0">{hexKeyValue} </p>
              </div>
              <div class="p-0 w-48">
                <h3>*Hexadecimal of "{key}"</h3>
              </div>

              <svg
                width="46"
                height="50"
                viewBox="0 0 31 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_253_6)">
                  <path
                    d="M14.4213 47.5319C15.0071 48.1176 15.9568 48.1176 16.5426 47.5319L26.0885 37.9859C26.6743 37.4001 26.6743 36.4504 26.0885 35.8646C25.5027 35.2788 24.553 35.2788 23.9672 35.8646L15.4819 44.3499L6.99665 35.8646C6.41087 35.2788 5.46112 35.2788 4.87533 35.8646C4.28955 36.4504 4.28955 37.4001 4.87533 37.9859L14.4213 47.5319ZM13.9819 0.471191L13.9819 46.4712H16.9819L16.9819 0.471191L13.9819 0.471191Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_253_6"
                    x="0.436035"
                    y="0.471191"
                    width="30.0918"
                    height="55.5"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_253_6"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_253_6"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <div className="bg-blue-700 text-white text-center border-solid  border-2 p-1 w-60 rounded-lg mb-0">
                <p>Per Round Key Generation</p>
                <button
                  className="bg-white text-black px-4 py-2 mt-2 rounded hover:bg-blue-200  transition duration-300"
                  onClick={Keygen}
                >
                  View
                </button>
                <div className="pb-4"></div>{" "}
                {/* Add padding below the button */}
              </div>

              <svg
                width="32"
                height="61"
                viewBox="0 0 32 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_347_4)">
                  <path
                    d="M14.9393 52.0607C15.5251 52.6464 16.4749 52.6464 17.0607 52.0607L26.6066 42.5147C27.1924 41.9289 27.1924 40.9792 26.6066 40.3934C26.0208 39.8076 25.0711 39.8076 24.4853 40.3934L16 48.8787L7.51472 40.3934C6.92893 39.8076 5.97919 39.8076 5.3934 40.3934C4.80761 40.9792 4.80761 41.9289 5.3934 42.5147L14.9393 52.0607ZM14.5 0.5V51H17.5V0.5L14.5 0.5Z"
                    fill="black"
                  />
                </g>
                <rect x="9" y="13" width="15" height="15" fill="black" />
                <defs>
                  <filter
                    id="filter0_d_347_4"
                    x="0.954102"
                    y="0.5"
                    width="30.0918"
                    height="60"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_347_4"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_347_4"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <div className="bg-blue-700 text-white text-center border-solid  border-2  w-60 rounded-lg mb-0">
                <p>Reverse Order</p>
                <div className="pb-4"></div>{" "}
                {/* Add padding below the button */}
              </div>

              <svg
                width="32"
                height="61"
                viewBox="0 0 32 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_347_4)">
                  <path
                    d="M14.9393 52.0607C15.5251 52.6464 16.4749 52.6464 17.0607 52.0607L26.6066 42.5147C27.1924 41.9289 27.1924 40.9792 26.6066 40.3934C26.0208 39.8076 25.0711 39.8076 24.4853 40.3934L16 48.8787L7.51472 40.3934C6.92893 39.8076 5.97919 39.8076 5.3934 40.3934C4.80761 40.9792 4.80761 41.9289 5.3934 42.5147L14.9393 52.0607ZM14.5 0.5V51H17.5V0.5L14.5 0.5Z"
                    fill="black"
                  />
                </g>
                <rect x="9" y="13" width="15" height="15" fill="black" />
                <defs>
                  <filter
                    id="filter0_d_347_4"
                    x="0.954102"
                    y="0.5"
                    width="30.0918"
                    height="60"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_347_4"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_347_4"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <div className="bg-blue-700 text-white text-center border-solid  border-2 p-1 w-60 rounded-lg mb-0">
                <p>16 Rounds</p>
                <button
                  className="bg-white text-black px-4 py-2 mt-2 rounded hover:bg-blue-200 transition duration-300"
                  onClick={viewRoundsPage}
                >
                  View
                </button>
                <div className="pb-4"></div>{" "}
                {/* Add padding below the button */}
              </div>
            </div>
            {/* {/Fourth grid/} */}
            <div class="ml-32">
              <svg
                width="82"
                height="293"
                viewBox="0 0 82 293"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="ml-3"
              >
                <path
                  d="M20.9436 12L20.9436 293"
                  stroke="black"
                  stroke-width="3"
                />
                <line
                  x1="20.3774"
                  y1="291.5"
                  x2="8.37749e-05"
                  y2="291.5"
                  stroke="black"
                  stroke-width="3"
                />
                <g filter="url(#filter0_d_347_9)">
                  <path
                    d="M77.4758 10.9393C78.0616 11.5251 78.0616 12.4749 77.4758 13.0607L67.9299 22.6066C67.3441 23.1924 66.3944 23.1924 65.8086 22.6066C65.2228 22.0208 65.2228 21.0711 65.8086 20.4853L74.2939 12L65.8086 3.51472C65.2228 2.92893 65.2228 1.97918 65.8086 1.3934C66.3944 0.807612 67.3441 0.807612 67.9299 1.3934L77.4758 10.9393ZM19.2454 10.5L76.4152 10.5V13.5L19.2454 13.5L19.2454 10.5Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_347_9"
                    x="15.2454"
                    y="0.954102"
                    width="66.6699"
                    height="30.0918"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_347_9"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_347_9"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            {/* {/Fifth grid/} */}
            <div>
              <div class="flex flex-col items-center justify-center h-screen ml-64">
                <h1 class="mt-0 mb-0 ">Final Round Output</h1>
                <div class="border-solid border-black border-2 p-0 w-60 relative">
                  <p class="m-0">{beforeSwap}</p>
                  <div class="absolute inset-y-0 left-1/2 border-solid border-l-2 border-black"></div>
                </div>

                <svg
                  width="74"
                  height="51"
                  viewBox="0 0 74 51"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.298653 48.9352C0.272051 49.6335 1.0122 50.2287 1.95183 50.2645L17.264 50.8478C18.2036 50.8836 18.9869 50.3464 19.0135 49.6481C19.0401 48.9497 18.2999 48.3546 17.3603 48.3188L3.74951 47.8003L4.13485 37.6845C4.16146 36.9862 3.4213 36.391 2.48167 36.3552C1.54205 36.3195 0.758762 36.8566 0.73216 37.5549L0.298653 48.9352ZM70.831 0.0600536L0.831025 48.0601L3.16897 49.94L73.169 1.93995L70.831 0.0600536Z"
                    fill="black"
                  />
                  <path
                    d="M72.0482 50.2645C72.9878 50.2287 73.728 49.6335 73.7014 48.9352L73.2678 37.5549C73.2412 36.8566 72.458 36.3195 71.5183 36.3552C70.5787 36.391 69.8385 36.9862 69.8652 37.6845L70.2505 47.8003L56.6397 48.3188C55.7001 48.3546 54.9599 48.9497 54.9865 49.6481C55.0131 50.3464 55.7964 50.8836 56.7361 50.8478L72.0482 50.2645ZM0.831026 1.93995L70.831 49.94L73.169 48.0601L3.16897 0.0600538L0.831026 1.93995Z"
                    fill="black"
                  />
                </svg>

                <div class="border-solid border-black border-2 p-0 w-60 relative">
                  <p class="m-0">{afterSwap}</p>
                  <div class="absolute inset-y-0 left-1/2 border-solid border-l-2 border-black"></div>
                </div>

                <p>Left/Right swap</p>

                <svg
                  width="23"
                  height="80"
                  viewBox="0 0 23 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.95141 79.0542C10.5335 79.6436 11.4833 79.6495 12.0727 79.0674L21.6777 69.5809C22.2671 68.9987 22.273 68.049 21.6909 67.4596C21.1088 66.8702 20.159 66.8643 19.5696 67.4464L11.0318 75.8788L2.59939 67.341C2.01726 66.7516 1.06753 66.7457 0.478114 67.3278C-0.111299 67.91 -0.117198 68.8597 0.464938 69.4491L9.95141 79.0542ZM10 0.490683L9.51866 77.9908L12.5186 78.0094L13 0.509317L10 0.490683Z"
                    fill="black"
                  />
                </svg>

                <div className="bg-blue-700 text-white text-center border-solid  border-2 p-1 w-60 rounded-lg  ">
                  <p>Final Permutation</p>
                  <button
                    className="bg-white text-black px-4 py-2 mt-2 rounded hover:bg-blue-200 transition duration-300"
                    onClick={fp}
                  >
                    View
                  </button>
                  <div className="pb-4"></div>{" "}
                  {/* Add padding below the button */}
                </div>
              </div>
            </div>
            {/* {/Sixth grid/} */}
            <div className="ml-64 mt-80">
              <svg
                width="80"
                height="23"
                viewBox="0 0 80 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="ml-3 mb]"
              >
                <path
                  d="M79.0708 12.3107C79.6566 11.7249 79.6566 10.7751 79.0708 10.1893L69.5249 0.643398C68.9391 0.0576118 67.9893 0.0576118 67.4036 0.643398C66.8178 1.22918 66.8178 2.17893 67.4036 2.76472L75.8888 11.25L67.4036 19.7353C66.8178 20.3211 66.8178 21.2708 67.4036 21.8566C67.9893 22.4424 68.9391 22.4424 69.5249 21.8566L79.0708 12.3107ZM0.508545 12.75L78.0102 12.75V9.75L0.508545 9.75V12.75Z"
                  fill="black"
                />
              </svg>
            </div>
            {/* {/Seventh grid/} */}
            <div className="ml-64 mt-80">
              <p>Plaintext</p>
              <div className="border-solid border-black border-2 p-0 m-1 w-48">
                <p>{DecryptedPlainText}</p>
              </div>
              <div class="p-0 w-48">
                <h3> *ASCII form is "{asciiDecryptedPlainText}"</h3>
              </div>
            </div>
          </div>
        </div>

        {/* <div>
            Plaintext: {hexplaintext}
            <br></br>
            Key: {hexkey}
            <br />
            Final Round Output: {AllexcryptionResults[2][15]} <br />
            Left/Right Swapped: {binary64bitValueSwapped} <br />
            Ciphertext: {cipherhex}
          </div> */}

        <div class="button-holder">
          <div class="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
        </div>
      </div>
    </>
  );
};
export default DecryptionView;
